import { useEffect, useRef, useState } from "react";
import styles from "../../style/style.module.css";
import Counter from "../counter";

const TrackRecord = () => {
  const ref = useRef(null);
  const [hrHeight, setHrHeight] = useState(0);

  useEffect(() => {
    setHrHeight(ref.current.offsetHeight);
    const handleResize = () => {
      if (ref.current) {
        setHrHeight(ref.current.offsetHeight);
        console.log(hrHeight);
      }
    };
    window.addEventListener("resize", handleResize);

    return window.removeEventListener("resize", handleResize);
  }, [hrHeight]);

  return (
    <>
      <div className={`${styles.services} overflow-hidden rounded-sm`}>
        <div className="flex w-full flex-col items-center justify-center gap-4 bg-visGray py-5 md:py-10">
          <p className="text-lg font-normal text-white opacity-70">
            OUR TRACK RECORD
          </p>
          <h1 className="text-center text-2xl font-bold text-white md:text-4xl">
            Helping Businesses Globally
          </h1>
          <div className="grid w-full grid-cols-12">
            <div className="col-span-6 lg:col-span-3">
              <div className="text-center">
                <div
                  ref={ref}
                  className="relative flex items-center justify-center py-3"
                >
                  <Counter from={0} to={14} />
                  <hr
                    style={{
                      width: `${hrHeight}px`,
                      right: `-${hrHeight / 1.95}px`,
                    }}
                    className="absolute rotate-[120deg]"
                  />
                </div>
                <p className="text text-base font-thin text-white md:text-lg">
                  Business Years
                </p>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3">
              <div className="text-center">
                <div
                  ref={ref}
                  className="relative flex items-center justify-center py-3"
                >
                  <Counter from={0} to={150} />
                  <hr
                    style={{
                      width: `${hrHeight}px`,
                      right: `-${hrHeight / 1.95}px`,
                    }}
                    className="absolute hidden rotate-[120deg] lg:block"
                  />
                </div>
                <p className="text text-base font-thin text-white md:text-lg">
                  Global Clients
                </p>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3">
              <div className="text-center">
                <div
                  ref={ref}
                  className="relative flex items-center justify-center py-3"
                >
                  <Counter from={0} to={400} />
                  <hr
                    style={{
                      width: `${hrHeight}px`,
                      right: `-${hrHeight / 1.95}px`,
                    }}
                    className="absolute rotate-[120deg]"
                  />
                </div>
                <p className="text text-base font-thin text-white md:text-lg">
                  Projects Delivery
                </p>
              </div>
            </div>
            <div className="col-span-6 lg:col-span-3">
              <div className="text-center">
                <div
                  ref={ref}
                  className="relative flex items-center justify-center py-3"
                >
                  <Counter from={0} to={120} />
                </div>
                <p className="text text-base font-thin text-white md:text-lg">
                  Team Members
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TrackRecord;
